import type { ReplicaStatus } from '../model/operations';

export type PageStatus = 'missingContext' | ReplicaStatus;

export type PageStatusInput = {
  hasChannel: boolean;
  hasTemplateId: boolean;
  replicaStatus: ReplicaStatus;
};

export function resolvePageStatus({
  hasChannel,
  hasTemplateId,
  replicaStatus,
}: PageStatusInput): PageStatus {
  if (!hasChannel || !hasTemplateId) {
    return 'missingContext';
  }

  return replicaStatus;
}
